import { Injectable, signal } from '@angular/core';
import { TroubleshootingResult, TroubleshootingResultKey } from './troubleshooting.datamodel';

@Injectable({
  providedIn: 'root'
})
export class TroubleshootingCacheService {
  readonly results = signal<TroubleshootingResult[]>([]);
  readonly selectedResult = signal<TroubleshootingResultKey | undefined>(undefined);

  cacheTroubleshooting(results: TroubleshootingResult[],
                       selectedResult?: TroubleshootingResultKey): void {
    this.results.set(results);
    this.selectedResult.set(selectedResult);
  }
}
